import TaskGroupStatus from 'FielderUtils/status/groupTaskStatus';
import TaskStatus from 'FielderUtils/status/taskStatus';
import AdvancedFilterUtilColum from './AdvancedFilterUtilColum';
import AdvancedFilterUtilOperator from './AdvancedFilterUtilOperator';
import AutoAssignStatus from 'FielderUtils/autoassign/processTaskStatus';
import { forEach } from 'lodash';

const PAUSE_BY_USER = 1;
const PAUSE_BY_AGENT = 0;
export const columnDataAvancedFilter = (lan) => [
	{ label: "idTask", value: AdvancedFilterUtilColum.ID_TASK, disabled: false, },
	{ label: "folio", value: AdvancedFilterUtilColum.FOLIO, disabled: false, },
	{ label: "caseNumber", value: AdvancedFilterUtilColum.CASE_NUMBER, disabled: false, },
	{ label: "typePauseReason", value: AdvancedFilterUtilColum.TYPE_PAUSE_REASON, disabled: false, },
	{ label: "pauseReason", value: AdvancedFilterUtilColum.PAUSE_REASON, disabled: false, },
	{ label: "priority", value: AdvancedFilterUtilColum.PRIORITY, disabled: false, },
	{ label: "typeOfTask", value: AdvancedFilterUtilColum.TYPE_OF_TASK, disabled: false, },
	{ label: "status", value: AdvancedFilterUtilColum.STATUS, disabled: false, },
	{ label: "idParentTask", value: AdvancedFilterUtilColum.ID_PARENT_TASK, disabled: false, },
	{ label: "partner", value: AdvancedFilterUtilColum.PARTNER, disabled: false, },
	{ label: "user", value: AdvancedFilterUtilColum.NAME, disabled: false, },
	{ label: "idBranch", value: AdvancedFilterUtilColum.BRANCH_ID, disabled: false, },
	{ label: "branchName", value: AdvancedFilterUtilColum.BRANCH_NAME, disabled: false, },
	{ label: "company", value: AdvancedFilterUtilColum.COMPANY, disabled: false, },
	{ label: "country", value: AdvancedFilterUtilColum.COUNTRY, disabled: false, },
	{ label: "directionClient", value: AdvancedFilterUtilColum.DIRECTION, disabled: false, },
	{ label: "agent", value: AdvancedFilterUtilColum.AGENT, disabled: false, },
  { label: "tags", value: AdvancedFilterUtilColum.TAGS, disabled: false, },
  { label: "group", value: AdvancedFilterUtilColum.GROUP, disabled: false, },
	{ label: "statusGroup", value: AdvancedFilterUtilColum.STATUS_GROUP, disabled: false, },
	{ label: "score", value: AdvancedFilterUtilColum.SCORE, disabled: false, },
];
export const getPrioritiesAdvancedFilter = (getPrioritiesAdvancedFilter, lan) => {
	const priorities = [];
	forEach(getPrioritiesAdvancedFilter, (priority) => {
		let label = priority.name;
		if (priority.id === 1 || priority.id === 2 || priority.id === 3) label = lan['severity_'+priority.id]
		priorities.push({ label: label, value: priority.id, disabled: false });
	});
	return priorities;
}
export const taskGroupStatusDataAvancedFilter = (lan) => [
	{ label: "CREATED", value: TaskGroupStatus.PAUSED, disabled: false, },
	{ label: "ON_WAY", value: TaskGroupStatus.ON_WAY, disabled: false, },
	{ label: "ARRIVE", value: TaskGroupStatus.ARRIVE, disabled: false, },
	{ label: "EXECUTING", value: TaskGroupStatus.EXECUTING, disabled: false, },
	{ label: "PAUSE", value: TaskGroupStatus.PAUSE, disabled: false, },
	{ label: "FINISH", value: TaskGroupStatus.FINISH, disabled: false, },
	{ label: "CANCELED", value: TaskGroupStatus.CANCELED, disabled: false, },
];
export const taskStatusDataAvancedFilter = (lan) => [
	{ label: "taskStatus_0", value: TaskStatus.MANAGING, disabled: false, },
	{ label: "taskStatus_1", value: TaskStatus.CANCEL, disabled: false, },
	{ label: "taskStatus_2", value: TaskStatus.FINISH, disabled: false, },
	{ label: "taskStatus_3", value: TaskStatus.WAITING_FOR_AGENT, disabled: false, },
	{ label: "taskStatus_4", value: TaskStatus.IN_PROGRESS, disabled: false, },
	{ label: "taskStatus_5", value: TaskStatus.EXECUTING, disabled: false, },
	{ label: "taskStatus_6", value: TaskStatus.START_ROUTE, disabled: false, },
	{ label: "taskStatus_7", value: TaskStatus.CANCEL_BY_PARTNER, disabled: false, },
	{ label: "taskStatus_8", value: TaskStatus.ASSIGNED_TO_PARTNER, disabled: false, },
	{ label: "taskStatus_9", value: TaskStatus.ASSIGNED_TO_TEAM, disabled: false, },
	{ label: "taskStatus_10", value: TaskStatus.ARRIVED, disabled: false, },
	{ label: "taskStatus_11", value: TaskStatus.DELETED, disabled: false, },
	{ label: "taskStatus_15", value: TaskStatus.PAUSED, disabled: false, },
];
export const operationDataAvancedFilter = (lan) => [
	{ label: "contain", },
];
export const operatorDataAvancedFilter = (lan) => [
	{ label: "andCapitalLetter", value: AdvancedFilterUtilOperator.AND, },
];
export const operatorCategoryDataAvancedFilter = (lan) => [
	{ label: `orCapitalLetter`, value: AdvancedFilterUtilOperator.OR, },
	{ label: `andCapitalLetter`, value: AdvancedFilterUtilOperator.AND_CATEGORY, },
];
export const typeOfPauseTaskAdvancedFilter = (lan) => [
	{ label: "pausedByFinalClient", value: PAUSE_BY_USER, disabled: false, },
	{ label: "pausedByAgent", value: PAUSE_BY_AGENT, disabled: false, }
];
// Smart filters
export const getAutoAssignStatusFilterOptions = (lan) => {
  return [
    { label: lan?.successful || 'Successful', value: AutoAssignStatus.SUCCESSFULL, disabled: false },
    { label: lan?.executingAutoassign || 'Executing', value: AutoAssignStatus.EXECUTING, disabled: false },
    { label: lan?.waiting || 'Waiting', value: AutoAssignStatus.WAITING, disabled: false },
    { label: lan?.retrying || 'Retrying', value: AutoAssignStatus.RETRYING, disabled: false },
    { label: lan?.noAgentAvailable || 'No Agent Available',
      value: AutoAssignStatus.FAILED_NO_AGENTS_AVAILABLE, disabled: false },
    { label: lan?.noSkills || 'No Skills', value: AutoAssignStatus.FAILED_NO_SKILLS, disabled: false },
    { label: lan?.agentsInMultipleTeams || 'Multiple Teams',
      value: AutoAssignStatus.FAILED_AVAILABLE_AGENTS_IN_MULTIPLE_TEAMS, disabled: false },
  ];
};
export const getTaskStatusFilterOptions = (lan) => {
  return [
    { label: lan.taskStatus_0, value: TaskStatus.MANAGING, disabled: false },
    { label: lan.taskStatus_1, value: TaskStatus.CANCEL, disabled: false },
    { label: lan.taskStatus_2, value: TaskStatus.FINISH, disabled: false },
    { label: lan.taskStatus_3, value: TaskStatus.WAITING_FOR_AGENT, disabled: false },
    { label: lan.taskStatus_4, value: TaskStatus.IN_PROGRESS, disabled: false },
    { label: lan.taskStatus_5, value: TaskStatus.EXECUTING, disabled: false },
    { label: lan.taskStatus_6, value: TaskStatus.START_ROUTE, disabled: false },
    { label: lan.taskStatus_7, value: TaskStatus.CANCEL_BY_PARTNER, disabled: false },
    { label: lan.taskStatus_8, value: TaskStatus.ASSIGNED_TO_PARTNER, disabled: false },
    { label: lan.taskStatus_9, value: TaskStatus.ASSIGNED_TO_TEAM, disabled: false },
    { label: lan.taskStatus_10, value: TaskStatus.ARRIVED, disabled: false },
    { label: lan.taskStatus_11, value: TaskStatus.DELETED, disabled: false },
    { label: lan.taskStatus_15, value: TaskStatus.PAUSED, disabled: false },
  ];
};
export const getTaskPriorityFilterOptions = (prioritiesData, lan) => {
  if (!Array.isArray(prioritiesData)) return [];
  return prioritiesData.map(priority => {
    let label = priority.label;
    if ([1, 2, 3].includes(priority.value)) label = lan[`severity_${priority.value}`] || label;
    return {
      label, value: priority.value, disabled: priority.disabled ?? false
    };
  });
};
